import ExternalScriptLoader, { providers } from './external-script-loader'
import { withLogger } from 'lib/logger'

const logger = withLogger('Greenhouse')
class Greenhouse extends ExternalScriptLoader {
  scriptUrl = 'https://boards.greenhouse.io/embed/job_board/js?for=barstoolsports'
  providerName = providers.greenhouse

  async load() {
    try {
      await this.loadScript()
      logger.log('load()')
      Grnhse.Iframe.load()
    } catch (err) {
      logger.error('load():', err)
    }
  }
}

export default new Greenhouse()
